import React, { createContext, useState, useEffect, useCallback } from 'react';

export const FormContext = createContext();

const LOCAL_STORAGE_KEY = 'invoiceMetaForm';

export const FormProvider = ({ children }) => {
  // Load from localStorage or fallback to default
  const getInitialState = () => {
    try {
      const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
      return saved ? JSON.parse(saved) : defaultState;
    } catch (e) {
      return defaultState;
    }
  };

  const defaultState = {
    
    followerCount: 0,
    activeMins: 0,
    postCount: 0,
    minsPerPost: 0,
    sharePct: 100,
    
    name: '',
    handle: '',
    email: '',
    paymentMethod: '',
    paymentAddress: '',
  };

  const [formData, setFormData] = useState(getInitialState);

  // Save to localStorage whenever formData changes
  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(formData));
  }, [formData]);

  const updateForm = useCallback((partial) => {
    setFormData((prev) => ({ ...prev, ...partial }));
  }, []);

  const updateReach = useCallback((partialReach) => {
    setFormData((prev) => ({
      ...prev,
      reach: { ...prev.reach, ...partialReach },
    }));
  }, []);

  return (
    <FormContext.Provider value={{ formData, updateForm, updateReach }}>
      {children}
    </FormContext.Provider>
  );
};
